export const showLoader = () => {
  const overlayingDiv = document.getElementById("global-overlay");
  if (overlayingDiv) overlayingDiv.style.display = "block";
};

export const hideLoader = () => {
  const overlayingDiv = document.getElementById("global-overlay");
  if (overlayingDiv) overlayingDiv.style.display = "none";
};
